import { useMemo } from 'react';

import { StripeVolumePricingConfig } from '../../../../shared/graphql/graphql';
import { calculateTiersFromArea } from '../helpers/functions/tiers';

export default function useSubscriptionExample({
  subscription,
  seats,
  planet,
}: {
  subscription: {
    amount: number;
    volumePricing?: StripeVolumePricingConfig[];
  };
  seats?: {
    amount: number;
    price: number;
  };
  planet?: {
    amount: number;
    price: number;
  };
}) {
  const areaAmount = subscription.amount;
  const seatAmount = seats?.amount ?? 0;
  const seatPrice = seats?.price ?? 0;
  const planetAmount = planet?.amount ?? 0;
  const planetPrice = planet?.price ?? 0;

  const tiers = useMemo(
    () => calculateTiersFromArea(areaAmount, subscription.volumePricing ?? []),
    [areaAmount, subscription.volumePricing],
  );

  const seatCost = seatAmount * seatPrice;
  const planetCost = planetAmount * planetPrice;
  const totalCost = useMemo(
    () =>
      tiers.reduce((sum, tier) => sum + tier.totalPrice, 0) +
      (seatCost || 0) +
      (planetCost || 0),
    [tiers, seatCost, planetCost],
  );

  const maxLimitExceeded = tiers.some((tier) => Number.isNaN(tier.totalPrice));

  return {
    totalCost,
    tiers: maxLimitExceeded ? [] : tiers,
    seats: {
      amount: seatAmount,
      price: seatPrice,
      cost: seatCost,
    },
    planet: {
      amount: planetAmount,
      price: planetPrice,
      cost: planetCost,
    },
  };
}
